<template>
  <div class="shrink" :style="{maxWidth:'130px'}" >
    <user-combobox
        v-model="user"
        :role-names="['repartidor','repartidorTercerizado']"
        hide-details
        dense
        @input="updateDeliveryUser"
        :clearable="clearable"
        :disabled="disabled"
    ></user-combobox>
  </div>

</template>

<script>
import {UserCombobox} from "@dracul/user-frontend";
import OrderProvider from "@/modules/delivery/providers/OrderProvider";

export default {
  name: "DeliveryUser",
  components: {UserCombobox},
  props: {
    order: {type: Object},
    disabled: {type: Boolean, default: false},
    clearable: {type: Boolean, default: false},
  },
  data() {
    return {
      user: null,
      loading: false
    }
  },
  mounted() {
    if(this.order.deliveryUser){
      this.user = this.order.deliveryUser.id
    }
  },
  methods: {
    updateDeliveryUser() {
      this.loading = true
      OrderProvider.updateOrderDeliveryUser({orderId: this.order.id, userId: this.user})
          .then((r) => this.$emit('orderUpdated',r.data.orderUpdateDeliveryUser))
          .finally(() => this.loading = false)
    },
  }
}
</script>

<style scoped>

</style>
